<div id="add-user" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <title class="uk-modal-title color-grey">Ajouter un nouvel utilisateur</title>
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="bold color-grey uk-text-uppercase">Ajouter un nouvel utilisateur</h2>
                <div class="uk-form-stacked" *ngIf="page === 1">
                    <div class="uk-margin">
                        <label class="label">Adresse e-mail</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="user.email" placeholder="jean.dupond@vop.mobi"
                                class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Mot de passe</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="user.password" placeholder="********"
                                class="input alt color-cold-grey bold uk-width-1-1" type="password">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Confirmation du mot de passe</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="passwordConfirmation" placeholder="********"
                                class="input alt color-cold-grey bold uk-width-1-1" type="password">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Prénom</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="user.firstName" placeholder="Jean"
                                class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Nom</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="user.lastName" placeholder="Dupond"
                                class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Âge</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="user.age" placeholder="25"
                                class="input alt color-cold-grey bold uk-width-1-1" type="number" min="0">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <div class="uk-inline uk-width-9-10 uk-text-left">
                            <label><input class="uk-radio" name="radio" type="radio" [(ngModel)]="user.gender"
                                    [value]="'male'"> Homme</label>
                            <label><input class="uk-radio uk-margin-small-left" name="radio" type="radio"
                                    [(ngModel)]="user.gender" [value]="'female'"> Femme</label>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Numéro de téléphone</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="user.mobile" placeholder="06 70 55 17 22"
                                class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin" *ngIf="session.role.ability === 'super-admin'">
                        <label class="label">Opérateur</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <select class="combo-list alt color-cold-grey bold uk-width-1-1" [(ngModel)]="selectedSocietyId">
                                <option [value]="0" disabled>Sélectionner un opérateur</option>
                                <option *ngFor="let s of societies" [value]="s.Id">{{ s.Name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="uk-form-stacked" *ngIf="page === 2">
                    <div class="uk-margin">
                        <label class="label">
                            Permis de conduire (recto)
                            <span *ngIf="drivingRecto && drivingRecto.name !== null" (click)="cancelPhoto(1)"
                                style="font-size: 13px; margin-top: 4px;"
                                class="color-dark-gray uk-text-uppercase uk-float-right pointer">Annuler</span>
                        </label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(1)" type="button">
                                <span *ngIf="drivingRecto === null">Ajouter une photo</span>
                                <span *ngIf="drivingRecto && drivingRecto.name !== null">{{ drivingRecto.name }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">
                            Permis de conduire (verso)
                            <span *ngIf="drivingVerso && drivingVerso.name !== null" (click)="cancelPhoto(2)"
                                style="font-size: 13px; margin-top: 4px;"
                                class="color-dark-gray uk-text-uppercase uk-float-right pointer">Annuler</span>
                        </label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(2)" type="button">
                                <span *ngIf="drivingVerso === null">Ajouter une photo</span>
                                <span *ngIf="drivingVerso && drivingVerso.name !== null">{{ drivingVerso.name }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">
                            Justificatif d'identité (recto)
                            <span *ngIf="idRecto && idRecto.name !== null" (click)="cancelPhoto(3)"
                                style="font-size: 13px; margin-top: 4px;"
                                class="color-dark-gray uk-text-uppercase uk-float-right pointer">Annuler</span>
                        </label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(3)" type="button">
                                <span *ngIf="idRecto === null">Ajouter une photo</span>
                                <span *ngIf="idRecto && idRecto.name !== null">{{ idRecto.name }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">
                            Justificatif d'identité (verso)
                            <span *ngIf="idVerso && idVerso.name !== null" (click)="cancelPhoto(4)"
                                style="font-size: 13px; margin-top: 4px;"
                                class="color-dark-gray uk-text-uppercase uk-float-right pointer">Annuler</span>
                        </label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(4)" type="button">
                                <span *ngIf="idVerso === null">Ajouter une photo</span>
                                <span *ngIf="idVerso && idVerso.name !== null">{{ idVerso.name }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button uk-modal-close" type="button">Annuler</button>
                <button (click)="prevPage()" *ngIf="page === 2" class="button uk-margin-small-left"
                    type="button">Précédent</button>
                <button (click)="register()" class="button uk-margin-small-left" type="button">
                    <span class="bold" *ngIf="loadingAccountCreation === false">Créer le compte</span>
                    <span class="bold" *ngIf="loadingAccountCreation === true">
                        <div style="width: 15px;" uk-spinner></div>
                    </span>
                </button>
            </p>
        </div>
    </div>
</div>